import { STORAGE_NAMES } from '../storageKey.js'

/**
 * @description 解析帮助反馈的用户存储范围，避免同一浏览器内不同账号共用评价状态
 * @param {Object} options - 用户状态
 * @param {boolean} options.isLoggedIn - 是否已登录
 * @param {Record<string, unknown>|null|undefined} options.userInfo - 当前用户信息
 * @returns {string} 访客范围、用户范围；登录态用户 ID 尚未就绪时返回空字符串
 */
export function resolveHelpFeedbackUserScope({ isLoggedIn, userInfo }) {
  if (!isLoggedIn) return 'guest'

  const userId = userInfo?.userId ?? userInfo?.id ?? userInfo?.cloud_code
  const normalizedUserId = String(userId ?? '').trim()
  if (!normalizedUserId) return ''

  return `user-${encodeURIComponent(normalizedUserId)}`
}

/**
 * @description 生成按用户和内容隔离的帮助反馈本地存储逻辑键名
 * @param {string|number} contentId - 内容 ID
 * @param {string} userScope - 用户存储范围
 * @returns {string} 逻辑键名；参数未就绪时返回空字符串
 */
export function buildHelpFeedbackStorageName(contentId, userScope) {
  const normalizedContentId = String(contentId ?? '').trim()
  const normalizedUserScope = String(userScope ?? '').trim()
  if (!normalizedContentId || !normalizedUserScope) return ''

  return `${STORAGE_NAMES.HELP_FEEDBACK}-${normalizedUserScope}-${normalizedContentId}`
}
